import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { Star, Users, ArrowRight, Sparkles } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

export const CTASection = () => {
  const { t, language } = useLanguage();
  const navigate = useNavigate();
  const { ref } = useRevealOnScroll<HTMLDivElement>();
  const ar = language === "ar";

  return (
    <section ref={ref} className="reveal-on-scroll">
      <div className="relative rounded-3xl overflow-hidden p-10 md:p-16 text-center bg-gradient-to-br from-primary via-primary-light to-primary shadow-2xl shadow-primary/40">
        <div aria-hidden className="absolute inset-0 pointer-events-none">
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[140%] aspect-square rounded-full border border-white/15" />
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[100%] aspect-square rounded-full border border-white/15" />
          <div className="absolute -top-24 -right-24 w-80 h-80 rounded-full bg-white/15 blur-3xl" />
          <div className="absolute -bottom-24 -left-24 w-80 h-80 rounded-full bg-white/15 blur-3xl" />
        </div>
        <div className="relative">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/15 border border-white/30 text-white text-[11px] font-semibold tracking-widest uppercase mb-6 backdrop-blur">
            <Sparkles className="w-3.5 h-3.5" />
            {ar ? "ابدأ حملتك الآن" : "Start your campaign now"}
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white tracking-tight mb-4">
            {ar ? "جاهز للعمل مع أفضل المؤثرين؟" : "Ready to work with top influencers?"}
          </h2>
          <p className="text-base md:text-xl text-white/85 max-w-2xl mx-auto mb-8">
            {ar
              ? "كن من أوائل العلامات التجارية التي تستفيد من شبكة المؤثرين المتنامية لدينا"
              : "Be among the first brands to leverage our growing influencer network for exceptional results"}
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <button
              onClick={() => navigate("/influencer-booking")}
              className="inline-flex items-center gap-2 h-12 px-7 rounded-full bg-white text-primary font-bold text-sm md:text-base shadow-2xl hover:-translate-y-1 transition-transform duration-300 group"
            >
              <Users className="w-4 h-4" />
              {t("bookInfluencer")}
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
            </button>
            <button
              onClick={() => navigate("/influencer-signup")}
              className="inline-flex items-center gap-2 h-12 px-6 rounded-full bg-transparent border border-white/40 text-white font-semibold text-sm md:text-base hover:bg-white/10 transition-colors"
            >
              <Star className="w-4 h-4" />
              {ar ? "انضم كمؤثر" : "Become an Influencer"}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
